import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#fafafa',
        },
        background: {
            default: '#0a0a0a',
            paper: '#141414',
        },
        text: {
            primary: '#fafafa',
            secondary: '#888888',
        },
        surface: {
            callout: '#1a1a1a',
            calloutAnswer: '#141414',
            qaQuestion: '#1a1a1a',
            tableHeader: '#1f1f1f',
            tableRowAlt: '#161616',
            tableRow: '#474747',
            calloutSide: '#ddd',
        },
        others: {
            barsBg: '#363636',
            barsAc: '#d0d0d0'
        },
        divider: '#2a2a2a',
    },

    typography: {
        fontFamily: '"IBM Plex Sans", sans-serif',
        fontSize: 15,

        h1: {
            fontFamily: '"IBM Plex Serif", serif',
            fontSize: '2rem',
            fontWeight: 600,
            lineHeight: 1.2,
        },
        h2: {
            fontFamily: '"IBM Plex Serif", serif',
            fontSize: '1.375rem',
            fontWeight: 600,
            lineHeight: 1.3,
        },
        h3: {
            fontFamily: '"IBM Plex Sans", sans-serif',
            fontSize: '0.9375rem',
            fontWeight: 600,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
        },
        h4: {
            fontFamily: '"IBM Plex Mono", monospace',
            fontSize: '0.8125rem',
            fontWeight: 600,
            color: '#666666',
        },
        body1: {
            fontFamily: '"IBM Plex Sans", sans-serif',
            fontSize: '0.9375rem',
            lineHeight: 1.7,
        },
        body2: {
            fontFamily: '"IBM Plex Sans", sans-serif',
            fontSize: '0.875rem',
            lineHeight: 1.7,
        },
        caption: {
            fontFamily: '"IBM Plex Mono", monospace',
            fontSize: '0.6875rem',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
        },
    },

    shape: {
        borderRadius: 0,
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: `
                @font-face {
                  font-family: 'IBM Plex Sans';
                  src: url('/fonts/IBM_Plex_Sans/IBMPlexSans-VariableFont_wdth,wght.ttf') format('truetype');
                  font-weight: 100 700;
                  font-style: normal;
                }
                @font-face {
                  font-family: 'IBM Plex Sans';
                  src: url('/fonts/IBM_Plex_Sans/IBMPlexSans-Italic-VariableFont_wdth,wght.ttf') format('truetype');
                  font-weight: 100 700;
                  font-style: italic;
                }
                @font-face {
                  font-family: 'IBM Plex Serif';
                  src: url('/fonts/IBM_Plex_Serif/IBMPlexSerif-Regular.ttf') format('truetype');
                  font-weight: 400;
                  font-style: normal;
                }
                @font-face {
                  font-family: 'IBM Plex Serif';
                  src: url('/fonts/IBM_Plex_Serif/IBMPlexSerif-Italic.ttf') format('truetype');
                  font-weight: 400;
                  font-style: italic;
                }
                @font-face {
                  font-family: 'IBM Plex Serif';
                  src: url('/fonts/IBM_Plex_Serif/IBMPlexSerif-SemiBold.ttf') format('truetype');
                  font-weight: 600;
                  font-style: normal;
                }
                @font-face {
                  font-family: 'IBM Plex Serif';
                  src: url('/fonts/IBM_Plex_Serif/IBMPlexSerif-SemiBoldItalic.ttf') format('truetype');
                  font-weight: 600;
                  font-style: italic;
                }
                @font-face {
                  font-family: 'IBM Plex Mono';
                  src: url('/fonts/IBM_Plex_Mono/IBMPlexMono-Regular.ttf') format('truetype');
                  font-weight: 400;
                  font-style: normal;
                }
                @font-face {
                  font-family: 'IBM Plex Mono';
                  src: url('/fonts/IBM_Plex_Mono/IBMPlexMono-SemiBold.ttf') format('truetype');
                  font-weight: 600;
                  font-style: normal;
                }
                body {
                  background-color: #0a0a0a;
                  color: #fafafa;
                }
                * {
                  box-sizing: border-box;
                }
  `,
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    textTransform: 'uppercase',
                    fontFamily: '"IBM Plex Mono", monospace',
                    fontSize: '0.6875rem',
                    letterSpacing: '0.08em',
                    fontWeight: 600,
                },
            },
        },

        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    '&.Mui-selected': {
                        backgroundColor: '#fafafa',
                        color: '#0a0a0a',
                        '&:hover': {
                            backgroundColor: '#ddd',
                        },
                    },
                },
            },
        },

        MuiDrawer: {
            styleOverrides: {
                paper: {
                    borderRadius: 0,
                    backgroundColor: '#111111',
                    borderRight: '2px solid #2a2a2a'
                },
            },
        },

        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: '#2a2a2a',
                },
            },
        },

        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    fontFamily: '"IBM Plex Mono", monospace',
                    fontSize: '0.625rem',
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                    height: 20,
                },
            },
        },
    },
});

export default darkTheme;
